"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeViewStyles = void 0;
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
exports.TreeViewStyles = {
    treeNode: react_1.css({
        color: "var(" + variables_1.RootColor.Gray.DARK_2 + ")",
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '2px 8px',
        cursor: 'pointer',
        transition: 'all .3s ease-in',
        borderRadius: 4,
        height: 25,
        border: 'none',
        outline: 'none',
        backgroundColor: 'white',
        '&:enabled:hover': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        },
        '&:focus': {
            boxShadow: "0px 0px 0px 4px var(" + variables_1.ThemeColor.Primary.LIGHT_4 + ")",
        },
        '&:disabled': react_1.css({
            color: "var(" + variables_1.TextColor.DISABLED + ")",
            cursor: 'not-allowed',
        }),
    }),
    title: react_1.css({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flexShrink: 1,
    }),
    chevron: react_1.css({
        flexShrink: 0,
        transformOrigin: 'center',
        transition: 'all .2s ease-in-out',
    }),
    selected: react_1.css({
        color: "var(" + variables_1.ThemeColor.Primary.DARK_2 + ")",
        backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_5 + ")",
        '&:enabled:hover': {
            backgroundColor: "var(" + variables_1.ThemeColor.Primary.LIGHT_4 + ")",
        },
        'svg path': {
            fill: "var(" + variables_1.ThemeColor.Primary.LIGHT_1 + ")",
        },
    }),
};
